import React from 'react';
export default function FormLink({ additionalClasses = [], onClick, text }) { const classes = ['link', 'link--sm', 'display-inline-block', 'mt-2'].concat(additionalClasses); return /*#__PURE__*/ React.createElement("a", { className: classes.join(' '), onClick: onClick }, text); }
